import { handleRequest } from "../utilities/requestHandler";

export const resetPassword = (req_body) =>
    handleRequest("post","/auth/reset-password",req_body);

export const getResetPasswordTokenInfo = (token) =>
    handleRequest("post", "/auth/reset-password-token-info", { token });
